import { render, staticRenderFns } from "./DrawingEditor.vue?vue&type=template&id=dbcbbfc8&"
import script from "./DrawingEditor.vue?vue&type=script&lang=js&"
export * from "./DrawingEditor.vue?vue&type=script&lang=js&"
import style0 from "./DrawingEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports